import Loadable from 'react-loadable';
import { RouteLoading } from './RouteLoading';

const PrePagamentoParametrizacaoDiaHorario = Loadable({
  loader: () => import('../views/PrePagamento/Parametrizacao/DiaHorario'),
  loading: RouteLoading,
});

const ChecklistPrePagamento = Loadable({
  loader: () => import('../views/PrePagamento/Parametrizacao/Checklist'),
  loading: RouteLoading,
});

const IncluirChecklist = Loadable({
  loader: () => import('../views/PrePagamento/Parametrizacao/IncluirChecklist'),
  loading: RouteLoading,
});

const EditarChecklist = Loadable({
  loader: () => import('../views/PrePagamento/Parametrizacao/EditarChecklist'),
  loading: RouteLoading,
});

const GrafometriaDashboard = Loadable({
  loader: () => import('../views/PrePagamento/GrafometriaDashboard'),
  loading: RouteLoading,
});

const ConsultaHierarquia = Loadable({
  loader: () =>
    import('../views/PrePagamento/Parametrizacao/ConsultaHierarquia'),
  loading: RouteLoading,
});

const EditarHierarquia = Loadable({
  loader: () =>
    import(
      '../views/PrePagamento/Parametrizacao/ConsultaHierarquia/Hierarquia'
    ),
  loading: RouteLoading,
});

const ParametrizacaoDocumentos = Loadable({
  loader: () =>
    import('../views/PrePagamento/Parametrizacao/Documentos'),
  loading: RouteLoading,
});

const ParametrizacaoDocumentosAbono = Loadable({
  loader: () =>
    import('../views/PrePagamento/Parametrizacao/Documentos/GrupoAbono'),
  loading: RouteLoading,
});

const Reanalise = Loadable({
  loader: () => import('../views/PrePagamento/Reanalise'),
  loading: RouteLoading,
});

const AnaliseExclusao = Loadable({
  loader: () => import('../views/PrePagamento/AnaliseExclusao'),
  loading: RouteLoading,
});

const MonitorComercial = Loadable({
  loader: () => import('../views/PrePagamento/MonitorComercial'),
  loading: RouteLoading,
});

const PreAnaliseRisco = Loadable({
  loader: () => import('../views/PrePagamento/PreCadastro/PreAnaliseRisco'),
  loading: RouteLoading,
});

const AnaliticoComercial = Loadable({
  loader: () => import('../views/PrePagamento/AnaliticoComercial'),
  loading: RouteLoading,
});
const VisualizarPreAnaliseRisco = Loadable({
  loader: () =>
    import(
      '../views/PrePagamento/PreCadastro/PreAnaliseRisco/VisualizarPreRisco'
    ),
  loading: RouteLoading,
});

const AnaliseRisco = Loadable({
  loader: () => import('../views/PrePagamento/AnaliseRisco'),
  loading: RouteLoading,
});

const VisualizarAnaliseRisco = Loadable({
  loader: () =>
    import('../views/PrePagamento/AnaliseRisco/VisualizarAnaliseRisco'),
  loading: RouteLoading,
});

const CadastroFull = Loadable({
  loader: () => import('../views/PrePagamento/PagamentoFull/CadastroFull'),
  loading: RouteLoading,
});

const ConsultaFull = Loadable({
  loader: () => import('../views/PrePagamento/PagamentoFull/ConsultaFull'),
  loading: RouteLoading,
});

const NovoGrupo = Loadable({
  loader: () => import('../views/PrePagamento/Parametrizacao/Documentos/NovoGrupo'),
  loading: RouteLoading,
});

const NovaCritica = Loadable({
  loader: () => import('../views/PrePagamento/Parametrizacao/Documentos/NovaCritica'),
  loading: RouteLoading,
});

const ParametrizacaoDocumentosCritica = Loadable({
  loader: () =>
    import('../views/PrePagamento/Parametrizacao/Documentos/Critica'),
  loading: RouteLoading,
});

const UploadCargaFavorecido = Loadable({
  loader: () =>
    import('../views/PrePagamento/CargaFavorecidos'),
  loading: RouteLoading,
});

const ConsultaPLD = Loadable({
  loader: () =>
    import('../views/PrePagamento/AnaliseSolicitacaoPonte/ConsultaPLD'),
  loading: RouteLoading,
})

const VideoSolicitacaoPAG = Loadable({
  loader: () =>
    import('../views/PrePagamento/VideoSolicitacaoPAG'),
  loading: RouteLoading,
})

const RoutePrePagamento = [
  {
    path: '/pre-pagamento/video-solicitacao-pag',
    exact: true,
    name: 'Video Solicitação PAG',
    component: VideoSolicitacaoPAG,
  },
  {
    path: '/pre-pagamento/parametrizacao/dia-horario',
    exact: true,
    name: 'Dia e Horário',
    component: PrePagamentoParametrizacaoDiaHorario,
  },
  {
    path: '/pre-pagamento/parametrizacao/checklist',
    exact: true,
    name: 'Checklist Pré Pagamento',
    component: ChecklistPrePagamento,
  },
  {
    path: '/pre-pagamento/parametrizacao/incluir-checklist',
    exact: true,
    name: 'Incluir Checklist Pré Pagamento',
    component: IncluirChecklist,
  },
  {
    path: '/pre-pagamento/parametrizacao/editar-checklist/:idChecklist',
    exact: true,
    name: 'Editar Checklist Pré Pagamento',
    component: EditarChecklist,
  },
  {
    path: '/pre-pagamento/assinatura-digital-dashboard',
    exact: true,
    name: 'Assinatura Digital',
    component: GrafometriaDashboard,
  },
  {
    path: '/pre-pagamento/parametrizacao/consulta-hierarquia',
    exact: true,
    name: 'Consulta de Hierarquia',
    component: ConsultaHierarquia,
  },
  {
    path: '/pre-pagamento/parametrizacao/editar-hierarquia/:idUsuario',
    exact: true,
    name: 'Atualização de Hierarquia',
    component: EditarHierarquia,
  },
  {
    path: '/pre-pagamento/parametrizacao/documentos',
    exact: true,
    name: 'Parametrização / Documentos',
    component: ParametrizacaoDocumentos,
  },
  {
    path: '/pre-pagamento/parametrizacao/documentos/abono/:idTipoDocto',
    exact: true,
    name: '',
    component: ParametrizacaoDocumentosAbono,
  },
  {
    path: '/pre-pagamento/reanalise',
    exact: true,
    name: 'Reanálise',
    component: Reanalise,
  },
  {
    path: '/pre-pagamento/analise-exclusao',
    exact: true,
    name: 'Análise de Exclusão',
    component: AnaliseExclusao,
  },
  {
    path: '/pre-pagamento/pre-analise-risco',
    exact: true,
    name: 'Pré-Análise de Risco',
    component: PreAnaliseRisco,
  },
  {
    path: '/pre-pagamento/pre-analise-risco/visualizar/:IdContrato',
    exact: true,
    name: '',
    component: VisualizarPreAnaliseRisco,
  },
  {
    path: '/pre-pagamento/monitor-comercial',
    exact: true,
    name: 'Monitor Comercial',
    component: MonitorComercial,
  },
  {
    path: '/pre-pagamento/analise-risco',
    exact: true,
    name: 'Análise de Risco',
    component: AnaliseRisco,
  },
  {
    path: '/pre-pagamento/analitico-comercial',
    exact: true,
    name: 'Analítico Comercial',
    component: AnaliticoComercial,
  },
  {
    path: '/pre-pagamento/analise-risco/visualizar/:IdContrato',
    exact: true,
    name: 'Visualizar Análise Risco',
    component: VisualizarAnaliseRisco,
  },
  {
    path: '/pre-pagamento/pagamento-full/cadastro-full',
    exact: true,
    name: 'Cadastro Full',
    component: CadastroFull,
  },
  {
    path: '/pre-pagamento/pagamento-full/consulta-full',
    exact: true,
    name: 'Pagamento Full / Consulta Full',
    component: ConsultaFull,
  },
  {
    path: '/pre-pagamento/parametrizacao/documentos/novo-grupo',
    exact: true,
    name: 'Novo Grupo Documental',
    component: NovoGrupo,
  },
  {
    path: '/pre-pagamento/parametrizacao/documentos/novo-documento',
    exact: true,
    name: 'Novo Documento',
    component: NovoGrupo,
  },
  {
    path: '/pre-pagamento/parametrizacao/documentos/edicao',
    name: 'Editar Documento',
    component: NovoGrupo,
  },
  {
    path: '/pre-pagamento/parametrizacao/critica-edicao',
    name: 'Editar Critica',
    component: NovaCritica,
  },
  {
    path: '/pre-pagamento/parametrizacao/critica-nova',
    name: 'Nova Critica',
    component: NovaCritica,
  },
  {
    path: '/pre-pagamento/parametrizacao/critica',
    exact: true,
    name: 'Parametrização / Crítica',
    component: ParametrizacaoDocumentosCritica,
  },
  {
    path: '/pre-pagamento/carga-favorecidos',
    exact: true,
    name: 'Carga Favorecidos',
    component: UploadCargaFavorecido,
  },
  {
    path: '/pre-pagamento/analise-e-solicitacao-de-ponte/consulta-pld/:idProposta',
    name: 'Análise e Solicitação de Ponte / Consulta PLD',
    component: ConsultaPLD,
  }
];

export { RoutePrePagamento };
